import { AgxColumn, AgxRow, AgxTypography } from '@urbanx/agx.ui-components2'
import ContractsIcon from 'components/sidebar/icons/contracts-icon'
import { ContentLayout, PageLayout } from 'layout'

const ContractsPlaceholderPage = () => {
  return (
    <PageLayout
      agentName=""
      primaryPageTitle="Contracts"
      pageIcon=<div className="iconContainer">
        <ContractsIcon />
      </div>
    >
      <ContentLayout hasSecondaryMenu={false}>
        <AgxRow fill justifyContent="center" alignItems="alignCenter">
          <AgxColumn gap="spacing-sm" alignItems="alignCenter">
            <AgxTypography
              id="contracts-placeholder-title"
              type="heading"
              size="large"
              color="var(--text-primary)"
            >
              Contracts
            </AgxTypography>
            <AgxTypography
              id="contracts-placeholder-copy"
              type="body"
              size="medium"
              color="var(--text-secondary)"
            >
              Placeholder page
            </AgxTypography>
          </AgxColumn>
        </AgxRow>
      </ContentLayout>
    </PageLayout>
  )
}

export default ContractsPlaceholderPage
